export default __webpack_public_path__ + "static/media/Coding.f063ba80.png";